import createItemFetcher from "../helpers/item";
import { combineDucks } from "../helpers/combineDucks";
export const dataUrl = ({ scenario, program, workspace, mode, datFileName: path, nifFileName: fileName }) => {
    const encodedPath = encodeURIComponent(path);
    const encodedFileName = encodeURIComponent(fileName);
    return `/api/v1/datfile/${scenario}/${workspace}/${program}/${mode}?path=${encodedPath}&filename=${encodedFileName}`;
};
const schemaUrl = ({ scenario, program, workspace, mode, nifFileName: path }) => {
    const encodedFileName = encodeURIComponent(path);
    return `/api/v1/schemafile/${scenario}/${workspace}/${program}/${mode}?filename=${encodedFileName}`;
};
const uischemaUrl = ({ scenario, program, workspace, mode, nifFileName: path }) => {
    const encodedFileName = encodeURIComponent(path);
    return `/api/v1/uischemafile/${scenario}/${workspace}/${program}/${mode}?filename=${encodedFileName}`;
};
const computeId = ({ scenario, program, workspace, mode, datFileName: path }) => {
    return `${scenario}_${workspace}_${program}_${mode}_${path}`;
};
export const panelFileDataFetcher = createItemFetcher(dataUrl, "PANEL_FILE_DATA", computeId);
export const panelFileSchemaFetcher = createItemFetcher(schemaUrl, "PANEL_FILE_SCHEMA", computeId);
export const panelFileUISchemaFetcher = createItemFetcher(uischemaUrl, "PANEL_FILE_UISCHEMA", computeId);
export const createPanelFile = () => {
    return combineDucks({
        data: panelFileDataFetcher,
        schema: panelFileSchemaFetcher,
        uiSchema: panelFileUISchemaFetcher
    });
};
//# sourceMappingURL=index.js.map